import React, { useEffect } from "react";
import Box from "@mui/material/Box";

import { useContentSize } from "containers/hooks/useWindowSize";
import FileView from "../Visuals/TreeMap";
import useTranslations from "containers/hooks/useLanguageHook";
import { setSidebarFilter } from "@store/filters/actions";
import { FilterType } from "@store/filters/types";
import { useAppDispatch } from "index";
import { setCurrentVisualization } from "@store/options/actions";
import { VisTypes } from "@store/options/types";
import { VisualizationPageHeader } from "../Components/VisualizationPageHeader";
const TreemapImage = new URL("../../../public/treemap.png", import.meta.url).href;

function TreemapPage() {
  const size = useContentSize();
  const { t } = useTranslations();
  const treemapRef = React.useRef<undefined | HTMLDivElement>(undefined);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSidebarFilter([FilterType.categories, FilterType.fileTypes]));
    dispatch(setCurrentVisualization(VisTypes.Files));
  }, []);

  return (
    <Box sx={{ alignItems: "center", backgroundColor: "background.paper" }} ref={treemapRef}>
      <VisualizationPageHeader
        title={t.Vis.TheFiles}
        help={{
          title: t.LandingPage.TreemapTitle,
          description: t.LandingPage.TreemapText,
          image: TreemapImage,
        }}
        reference={treemapRef}
      />

      <FileView
        settings={{
          width: size.width,
          height: size.height,
        }}
      />
    </Box>
  );
}

export { TreemapPage };
